import { useCallback } from "react";
import {
  DownloadUrlQuery,
  DownloadUrlQueryVariables,
  FileGalleryFragment,
  FileFragment,
} from "gql/graphql";
import DOWNLOAD_URL_QUERY from "modules/drawers/networking/download-url";
import useBurstQuery from "./use-burst-query";

const useDownloadFile = (file: FileGalleryFragment | FileFragment) => {
  const [downloadUrlAPI] = useBurstQuery<
    DownloadUrlQuery,
    DownloadUrlQueryVariables
  >(DOWNLOAD_URL_QUERY);

  const downloadFile = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      const data = await downloadUrlAPI({
        variables: { fileId: file.id },
      });
      const link = document.createElement("a");
      link.download = file.name;
      link.href = data.data.downloadUrl;
      link.click();
    },
    [downloadUrlAPI, file.id, file.name],
  );
  return {
    downloadFile,
  };
};

export default useDownloadFile;
